import React from 'react';

export default function GridIcon(props) {
  return (
    <svg width={props.size} height={props.size} viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" {...props}>
        {/* Generator: Sketch 59.1 (86144) - https://sketch.com */}
        <title>🎨 Style</title>
      <desc>Created with Sketch.</desc>
      <g id="Symbols" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
        <g id="icons/grid/grid_outline" transform="translate(-2.000000, -2.000000)" fill={props.color}>
          <path d="M4,4 L4,9 L9,9 L9,4 L4,4 Z M2,2 L11,2 L11,11 L2,11 L2,2 Z M4,15 L4,20 L9,20 L9,15 L4,15 Z M2,13 L11,13 L11,22 L2,22 L2,13 Z M15,4 L15,9 L20,9 L20,4 L15,4 Z M13,2 L22,2 L22,11 L13,11 L13,2 Z M15,15 L15,20 L20,20 L20,15 L15,15 Z M13,13 L22,13 L22,22 L13,22 L13,13 Z" id="🎨-Style" />
        </g>
      </g>
    </svg>
  );
}
